import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Terms = styled.div`
  margin: 4em 0 0 0;

  h1 {
    text-align: center;
    margin: 0 auto 1em auto;
    max-width: 470px;
  }
`;

export const TermsWrap = styled.div `
  color: ${colors.BODY};
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  letter-spacing: 0;
  margin: 0 0 51px;
  font-family: neue-haas-unica, sans-serif;
  font-weight: 400;
  > strong {
    text-transform: none;
  }
`;




// WEBPACK FOOTER //
// ./src/containers/TermsPage/styledComponents.js